import React, { useEffect, useState } from 'react'
import { Link, useLocation, useHistory } from 'react-router-dom'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Badge from '@mui/material/Badge'
// import ListSubheader from '@mui/material/ListSubheader'
import DashboardIcon from '@mui/icons-material/Dashboard'
import StoreIcon from '@mui/icons-material/Store'
import PeopleIcon from '@mui/icons-material/People'
import PaidIcon from '@mui/icons-material/Paid'
import Divider from '@mui/material/Divider'
import CampaignIcon from '@mui/icons-material/Campaign'
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer'
import PhotoCameraBackIcon from '@mui/icons-material/PhotoCameraBack'
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun'
import FlagIcon from '@mui/icons-material/Flag'
import LanguageIcon from '@mui/icons-material/Language'
import MapIcon from '@mui/icons-material/Map'
import PaletteIcon from '@mui/icons-material/Palette'
import PermMediaIcon from '@mui/icons-material/PermMedia'
import SettingsIcon from '@mui/icons-material/Settings'
import CardMembershipIcon from '@mui/icons-material/CardMembership'
import FactCheckIcon from '@mui/icons-material/FactCheck'
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'
import PolicyIcon from '@mui/icons-material/Policy'
import ReviewsIcon from '@mui/icons-material/Reviews'
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism'
import BusinessIcon from '@mui/icons-material/Business'
import ContactMailIcon from '@mui/icons-material/ContactMail'
import EmailIcon from '@mui/icons-material/Email'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import API from './Axios'
import { ADMIN_ACCESS_MODES } from '../utils/sessionUtils'

export default function Sidebar({ auth, role, adminId, accessMode }) {
    const history = useHistory()
    const location = useLocation()
    const { pathname } = location
    // console.log(location)
    const splitLocation = pathname.split("/")
    const countryMetricsSelected = ['appGeoAnalytics', 'appCountrySignups'].includes(splitLocation[1])
        || (accessMode === ADMIN_ACCESS_MODES.COUNTRY_ANALYTICS_ONLY && pathname === '/')
    // console.log(splitLocation)
    // splitLocation.map(item => console.log(item))
    const backgroundColor = 'action.selected'
    const [receivedOrderClaimCount, setReceivedOrderClaimCount] = useState(0)
    const [unansweredQnaCount, setUnansweredQnaCount] = useState(0)
    const [unansweredProductQnaCount, setUnansweredProductQnaCount] = useState(0)
    const [unansweredAppQnaCount, setUnansweredAppQnaCount] = useState(0)
    const [unsentRecordCount, setUnsentRecordCount] = useState(0)

    useEffect(() => {
        if (!auth || accessMode === ADMIN_ACCESS_MODES.COUNTRY_ANALYTICS_ONLY) {
            setReceivedOrderClaimCount(0)
            setUnansweredQnaCount(0)
            setUnansweredProductQnaCount(0)
            setUnansweredAppQnaCount(0)
            setUnsentRecordCount(0)
            return
        }

        let isMounted = true

        const getSidebarBadgeCounts = async () => {
            try {
                const [orderClaimResult, qnaResult, productQnaResult, appQnaResult, recordResult] = await Promise.all([
                    role >= 4 ? API.post('/api/v1/admin/orderClaim/getList', {
                        page: 1,
                        offset: 1,
                        searchText: '',
                        searchSelect: {
                            searchClaimType: 0,
                            searchStatus: 1
                        }
                    }) : Promise.resolve(null),
                    role >= 4 ? API.post('/api/v1/admin/qna/getQnaList', {
                        page: 1,
                        offset: 1,
                        searchText: '',
                        searchSelect: {
                            searchType: 99,
                            searchStatus: 0
                        }
                    }) : Promise.resolve(null),
                    role >= 4 ? API.post('/api/v1/admin/productQna/getProductQnaList', {
                        page: 1,
                        offset: 1,
                        adminId,
                        role,
                        searchText: '',
                        searchSelect: {
                            searchType: '',
                            searchStatus: '0'
                        }
                    }) : Promise.resolve(null),
                    role > 1 ? API.post('/api/v1/admin/appQna/getList', {
                        page: 1,
                        offset: 1,
                        searchText: '',
                        searchSelect: {
                            searchDeviceType: '',
                            searchType: 0,
                            searchStatus: 0
                        }
                    }) : Promise.resolve(null),
                    role >= 4 ? API.post('/api/v1/admin/record/getList', {
                        page: 1,
                        offset: 1,
                        adminId,
                        role,
                        searchText: '',
                        searchSelect: {
                            searchType: 0,
                            searchStatus: 0,
                            productId: 0
                        }
                    }) : Promise.resolve(null)
                ])

                if (!isMounted) {
                    return
                }

                const hasForbidden = [orderClaimResult, qnaResult, productQnaResult, appQnaResult, recordResult]
                    .filter(Boolean)
                    .some((result) => result.data.code === 403)

                if (hasForbidden) {
                    history.push('/login')
                    return
                }

                setReceivedOrderClaimCount(role >= 4 && orderClaimResult?.data.code === 200 ? Number(orderClaimResult.data.data?.count || 0) : 0)
                setUnansweredQnaCount(role >= 4 && qnaResult?.data.code === 1 ? Number(qnaResult.data.data?.count || 0) : 0)
                setUnansweredProductQnaCount(role >= 4 && productQnaResult?.data.code === 1 ? Number(productQnaResult.data.data?.count || 0) : 0)
                setUnansweredAppQnaCount(role > 1 && appQnaResult?.data.code === 200 ? Number(appQnaResult.data.data?.count || 0) : 0)
                setUnsentRecordCount(role >= 4 && recordResult?.data.code === 200 ? Number(recordResult.data.data?.count || 0) : 0)
            } catch (error) {
                console.error('getSidebarBadgeCounts error:', error)
                if (isMounted) {
                    setReceivedOrderClaimCount(0)
                    setUnansweredQnaCount(0)
                    setUnansweredProductQnaCount(0)
                    setUnansweredAppQnaCount(0)
                    setUnsentRecordCount(0)
                }
            }
        }

        getSidebarBadgeCounts()

        return () => {
            isMounted = false
        }
    }, [accessMode, adminId, auth, history, pathname, role])

    if (auth && accessMode === ADMIN_ACCESS_MODES.COUNTRY_ANALYTICS_ONLY) {
        return (
            <div>
                <Link to="/appGeoAnalytics" className="link">
                    <ListItemButton sx={{ backgroundColor: countryMetricsSelected ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <LanguageIcon color={countryMetricsSelected ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="국가별 지표" />
                    </ListItemButton>
                </Link>
            </div>
        )
    }


    return (
        <div>
            {auth && role >= 4 &&
                <>
                <Link to="/" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === '' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <DashboardIcon color={splitLocation[1] === '' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="Dashboard" />
                    </ListItemButton>
                </Link>
                <Link to="/googleAds" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'googleAds' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <CampaignIcon color={splitLocation[1] === 'googleAds' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="Google Ads" />
                    </ListItemButton>
                </Link>
                <Link to="/appGeoAnalytics" className="link">
                    <ListItemButton sx={{ backgroundColor: countryMetricsSelected ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <LanguageIcon color={countryMetricsSelected ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="국가별 지표" />
                    </ListItemButton>
                </Link>
                </>
            }
            {auth && role >= 2 && (
                <Link to="/onboardingFunnel" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'onboardingFunnel' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <AccountTreeIcon color={splitLocation[1] === 'onboardingFunnel' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="온보딩 퍼널" />
                    </ListItemButton>
                </Link>
            )}
            {auth && role >= 4 &&
                <>
                <Link to="/settings" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'settings' || splitLocation[1] === 'setting' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <SettingsIcon color={splitLocation[1] === 'settings' || splitLocation[1] === 'setting' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="설정" />
                    </ListItemButton>
                </Link>
                <Link to="/users" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('user') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <PeopleIcon color={splitLocation[1].includes('user') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="회원" />
                    </ListItemButton>
                </Link>
                <Link to="/orderClaims" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('orderClaim') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <Badge
                                badgeContent={receivedOrderClaimCount}
                                color="error"
                                max={99}
                                invisible={receivedOrderClaimCount === 0}
                            >
                                <PaidIcon color={splitLocation[1].includes('orderClaim') ? 'secondary' : ''}/>
                            </Badge>
                        </ListItemIcon>
                        <ListItemText primary="환불/반품 신청" />
                    </ListItemButton>
                </Link>
                <Link to="/payments" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('payment') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <PaidIcon color={splitLocation[1].includes('payment') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="결제" />
                    </ListItemButton>
                </Link>
                <Link to="/memberships" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'memberships' || splitLocation[1] === 'membership' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <CardMembershipIcon color={splitLocation[1] === 'memberships' || splitLocation[1] === 'membership' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="멤버십" />
                    </ListItemButton>
                </Link>
                <Link to="/membership-reconciliation" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'membership-reconciliation' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <FactCheckIcon color={splitLocation[1] === 'membership-reconciliation' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="멤버십 점검" />
                    </ListItemButton>
                </Link>
                </>
            }
            {auth && role >= 2 && (
                <Link to="/membership-funnel" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'membership-funnel' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <AccountTreeIcon color={splitLocation[1] === 'membership-funnel' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="멤버십 퍼널" />
                    </ListItemButton>
                </Link>
            )}
            {auth && role >= 4 &&
                <>
                <Link to="/orderShippings" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('orderShipping') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <LocalShippingIcon color={splitLocation[1].includes('orderShipping') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="배송" />
                    </ListItemButton>
                </Link>
                <Link to="/products" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'products' || splitLocation[1] === 'product' || 
                        splitLocation[1] === 'new-product' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <StoreIcon color={splitLocation[1] === 'products' || splitLocation[1] === 'product' || 
                                splitLocation[1] === 'new-product' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="대회" />
                    </ListItemButton>
                </Link>
                <Link to="/best" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('best') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <StoreIcon color={splitLocation[1].includes('best') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="베스트상품" />
                    </ListItemButton>
                </Link>
                <Link to="/homeTop10Promotions" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'homeTop10Promotions' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <EmojiEventsIcon color={splitLocation[1] === 'homeTop10Promotions' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="홈 TOP10 관리" />
                    </ListItemButton>
                </Link>
                <Link to="/animals" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'animals' || splitLocation[1] === 'animal' || splitLocation[1] === 'new-animal' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <StoreIcon color={splitLocation[1] === 'animals' || splitLocation[1] === 'animal' || splitLocation[1] === 'new-animal' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="애니멀런" />
                    </ListItemButton>
                </Link>
                <Link to="/animal-packages" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'animal-packages' || splitLocation[1] === 'animal-package' || splitLocation[1] === 'new-animal-package' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <StoreIcon color={splitLocation[1] === 'animal-packages' || splitLocation[1] === 'animal-package' || splitLocation[1] === 'new-animal-package' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="패키지 상품" />
                    </ListItemButton>
                </Link>
                <Link to="/animal-package-codes" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'animal-package-codes' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <CardGiftcardIcon color={splitLocation[1] === 'animal-package-codes' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="패키지 활성화 코드" />
                    </ListItemButton>
                </Link>
                <Link to="/point-coupon-codes" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'point-coupon-codes' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <CardGiftcardIcon color={splitLocation[1] === 'point-coupon-codes' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="패키지 포인트 코드" />
                    </ListItemButton>
                </Link>
                <Link to="/new-records" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('new-record') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <Badge
                                badgeContent={unsentRecordCount}
                                color="error"
                                max={99}
                                invisible={unsentRecordCount === 0}
                            >
                                <PhotoCameraBackIcon color={splitLocation[1].includes('new-record') ? 'secondary' : ''}/>
                            </Badge>
                        </ListItemIcon>
                        <ListItemText primary="완주기록증" />
                    </ListItemButton>
                </Link>
            {/* <ListSubheader inset>setup</ListSubheader> */}
                <Link to="/bannerV2" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'bannerV2' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <PhotoCameraBackIcon color={splitLocation[1] === 'bannerV2' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="배너(V2) 관리" />
                    </ListItemButton>
                </Link>
                
                {/* <Link to="/notices" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('notice') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <CampaignIcon color={splitLocation[1].includes('notice') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="공지사항" />
                    </ListItemButton>
                </Link> */}
                {/* <Link to="/faqs" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('faq') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <AssignmentIcon color={splitLocation[1].includes('faq') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="자주하는질문" />
                    </ListItemButton>
                </Link> */}
                <Link to="/qnas" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'qnas' || splitLocation[1] === 'qna' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <Badge
                                badgeContent={unansweredQnaCount}
                                color="error"
                                max={99}
                                invisible={unansweredQnaCount === 0}
                            >
                                <QuestionAnswerIcon color={splitLocation[1] === 'qnas' || splitLocation[1] === 'qna' ? 'secondary' : ''}/>
                            </Badge>
                        </ListItemIcon>
                        <ListItemText primary="문의" />
                    </ListItemButton>
                </Link>
                <Link to="/productQnas" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'productQnas' || splitLocation[1] === 'productQna' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <Badge
                                badgeContent={unansweredProductQnaCount}
                                color="error"
                                max={99}
                                invisible={unansweredProductQnaCount === 0}
                            >
                                <QuestionAnswerIcon color={splitLocation[1] === 'productQnas' || splitLocation[1] === 'productQna' ? 'secondary' : ''}/>
                            </Badge>
                        </ListItemIcon>
                        <ListItemText primary="상품 문의" />
                    </ListItemButton>
                </Link>
                <Link to="/meetAddRequests" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'meetAddRequests' || splitLocation[1] === 'meetAddRequest' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <QuestionAnswerIcon color={splitLocation[1] === 'meetAddRequests' || splitLocation[1] === 'meetAddRequest' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="대회 등록 문의" />
                    </ListItemButton>
                </Link>
                
                {/* <Link to="/admins" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('admin') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <PeopleIcon color={splitLocation[1].includes('admin') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="업체" />
                    </ListItemButton>
                </Link>
                <Link to="/shippingFees" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('shippingFee') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <DirectionsCarIcon color={splitLocation[1].includes('shippingFee') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="배송비" />
                    </ListItemButton>
                </Link> */}
            {/* {auth &&
                <Link to="/password" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('password') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <PasswordIcon color={splitLocation[1].includes('password') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="Password" />
                    </ListItemButton>
                </Link>
            } */}
                <Divider />
                </>
            }
            {auth && role >= 3 &&
                <>
                <Link to="/medalPortfolios" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'medalPortfolios' || splitLocation[1] === 'medalPortfolio' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <EmojiEventsIcon color={splitLocation[1] === 'medalPortfolios' || splitLocation[1] === 'medalPortfolio' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="메달 포트폴리오" />
                    </ListItemButton>
                </Link>
                <Link to="/medalProducts" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'medalProducts' || splitLocation[1] === 'medalProduct' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <EmojiEventsIcon color={splitLocation[1] === 'medalProducts' || splitLocation[1] === 'medalProduct' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="메달 정보" />
                    </ListItemButton>
                </Link>
                <Link to="/medalProductSpecs" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'medalProductSpecs' || splitLocation[1] === 'medalProductSpec' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <EmojiEventsIcon color={splitLocation[1] === 'medalProductSpecs' || splitLocation[1] === 'medalProductSpec' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="메달 규격" />
                    </ListItemButton>
                </Link>
                <Link to="/medalProductOptions" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'medalProductOptions' || splitLocation[1] === 'medalProductOption' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <EmojiEventsIcon color={splitLocation[1] === 'medalProductOptions' || splitLocation[1] === 'medalProductOption' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="메달 옵션" />
                    </ListItemButton>
                </Link>
                <Link to="/medalOrders" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'medalOrders' || splitLocation[1] === 'medalOrder' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <EmojiEventsIcon color={splitLocation[1] === 'medalOrders' || splitLocation[1] === 'medalOrder' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="메달 견적서" />
                    </ListItemButton>
                </Link>
                <Divider />
                </>
            }
            {auth && role >= 5 &&
                <Link to="/appAccessRules" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'appAccessRules' || splitLocation[1] === 'appAccessRule' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <PolicyIcon color={splitLocation[1] === 'appAccessRules' || splitLocation[1] === 'appAccessRule' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 정책 설정" />
                    </ListItemButton>
                </Link>
            }
            {auth && role > 2 &&
                <>
                {role === 3 &&
                    <Link to="/users" className="link">
                        <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('user') ? backgroundColor : '' }}>
                            <ListItemIcon>
                                <PeopleIcon color={splitLocation[1].includes('user') ? 'secondary' : ''}/>
                            </ListItemIcon>
                            <ListItemText primary="회원" />
                        </ListItemButton>
                    </Link>
                }
                {/* 경품 규칙과 지급 내역은 한 메뉴 안에서 탭으로 오간다. */}
                <Link to="/appRankingBanners" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appRanking') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <CardGiftcardIcon color={splitLocation[1].includes('appRanking') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 랭킹경품" />
                    </ListItemButton>
                </Link>
                <Link to="/appTabPromotions" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appTabPromotion') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <PermMediaIcon color={splitLocation[1].includes('appTabPromotion') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 탭 프로모션" />
                    </ListItemButton>
                </Link>
                <Link to="/coupangRunningOwnedProducts" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'coupangRunningOwnedProducts' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <StoreIcon color={splitLocation[1] === 'coupangRunningOwnedProducts' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 러너 필수템" />
                    </ListItemButton>
                </Link>
                <Link to="/appMeetWes" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appMeetWe') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <DirectionsRunIcon color={splitLocation[1].includes('appMeetWe') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 우리끼리" />
                    </ListItemButton>
                </Link>
                <Link to="/appInfoMeetWes" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appInfoMeetWe') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <DirectionsRunIcon color={splitLocation[1].includes('appInfoMeetWe') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 우리끼리안내" />
                    </ListItemButton>
                </Link>
                </>
            }
            {auth && role > 3 &&
                <>
                <Link to="/countrys" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('country') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <LanguageIcon color={splitLocation[1].includes('country') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 국가" />
                    </ListItemButton>
                </Link>
                {/* <Link to="/appCoupangBanners" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appCoupangBanner') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <PhotoCameraBackIcon color={splitLocation[1].includes('appCoupangBanner') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 최저가배너" />
                    </ListItemButton>
                </Link>
                <Link to="/sports" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('sport') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <FitnessCenterIcon color={splitLocation[1].includes('sport') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 운동시설" />
                    </ListItemButton>
                </Link>
                <Link to="/appReviews" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appReview') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <ReviewsIcon color={splitLocation[1].includes('appReview') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 리뷰관리" />
                    </ListItemButton>
                </Link>
                <Link to="/appSportsReviews" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appSportsReview') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <ReviewsIcon color={splitLocation[1].includes('appSportsReview') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 리뷰작업" />
                    </ListItemButton>
                </Link> */}
                <Link to="/appBlocks" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appBlock') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <PeopleIcon color={splitLocation[1].includes('appBlock') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 계정정지" />
                    </ListItemButton>
                </Link>
                </>
            }
            {auth && role > 2 &&
                <>
                <Link to="/appBanners" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appBanner') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <PhotoCameraBackIcon color={splitLocation[1].includes('appBanner') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 배너" />
                    </ListItemButton>
                </Link>
                <Link to="/appNotices" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appNotice') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <CampaignIcon color={splitLocation[1].includes('appNotice') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 공지사항" />
                    </ListItemButton>
                </Link>
                <Link to="/appSeasons" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appSeason') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <FlagIcon color={splitLocation[1].includes('appSeason') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 별주부전" />
                    </ListItemButton>
                </Link>
                <Link to="/appPopups" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appPopup') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <PermMediaIcon color={splitLocation[1].includes('appPopup') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 팝업" />
                    </ListItemButton>
                </Link>
                <Link to="/appPushs" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appPush') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <CampaignIcon color={splitLocation[1].includes('appPush') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 푸시" />
                    </ListItemButton>
                </Link>
                </>
            }
            
            {auth && ( role === 2 || role === 5) &&
                <Link to="/appVersions" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appVersion') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <SettingsIcon color={splitLocation[1].includes('appVersion') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 버전" />
                    </ListItemButton>
                </Link>
            }
            {auth && role === 5 &&
                <>
                <Link to="/appRunnings" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appRunning') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <MapIcon color={splitLocation[1].includes('appRunning') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 러닝" />
                    </ListItemButton>
                </Link>
                <Link to="/appTerritorySkins" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appTerritorySkin') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <PaletteIcon color={splitLocation[1].includes('appTerritorySkin') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 땅따먹기 스킨" />
                    </ListItemButton>
                </Link>
                </>
            }
            {auth && role > 1 &&
                <Link to="/appQnas" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appQna') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <Badge
                                badgeContent={unansweredAppQnaCount}
                                color="error"
                                max={99}
                                invisible={unansweredAppQnaCount === 0}
                            >
                                <QuestionAnswerIcon color={splitLocation[1].includes('appQna') ? 'secondary' : ''}/>
                            </Badge>
                        </ListItemIcon>
                        <ListItemText primary="APP 문의" />
                    </ListItemButton>
                </Link>
            }
            {auth && role >= 4 &&
                <Link to="/appReviewEvents" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appReviewEvent') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <ReviewsIcon color={splitLocation[1].includes('appReviewEvent') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 리뷰이벤트" />
                    </ListItemButton>
                </Link>
            }
            {auth && role >= 3 &&
                <Link to="/appGifticonCategorys" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appGifticonCategory') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <CardGiftcardIcon color={splitLocation[1].includes('appGifticonCategory') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="APP 기프티콘 카테고리" />
                    </ListItemButton>
                </Link>
            }
            {auth && role >= 2 &&
                <Link to="/appGifticonExchanges" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appGifticonExchange') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <CardGiftcardIcon color={splitLocation[1].includes('appGifticonExchange') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="기프티콘 교환내역" />
                    </ListItemButton>
                </Link>
            }
            {auth && role >= 4 &&
                <Link to="/donations" className="link">
                    <ListItemButton sx={{ backgroundColor: ['donations', 'donation', 'new-donation'].includes(splitLocation[1]) ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <VolunteerActivismIcon color={['donations', 'donation', 'new-donation'].includes(splitLocation[1]) ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="포인트 기부 상품" />
                    </ListItemButton>
                </Link>
            }
            {auth && role >= 2 &&
                <Link to="/donationExchanges" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1] === 'donationExchanges' ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <PaidIcon color={splitLocation[1] === 'donationExchanges' ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="포인트 기부 내역" />
                    </ListItemButton>
                </Link>
            }
            <Divider />
            {auth && role >= 4 &&
            <>
                <Link to="/appCompanys" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appCompany') 
                        && !splitLocation[1].includes('appCompanyDomain')
                        && !splitLocation[1].includes('appCompanyContact')
                        && !splitLocation[1].includes('appCompanyContactImage') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <BusinessIcon color={splitLocation[1].includes('appCompany')
                                && !splitLocation[1].includes('appCompanyDomain')
                                && !splitLocation[1].includes('appCompanyContact')
                                && !splitLocation[1].includes('appCompanyContactImage') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="기업" />
                    </ListItemButton>
                </Link>
                <Link to="/appCompanyDomains" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appCompanyDomain') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <BusinessIcon color={splitLocation[1].includes('appCompanyDomain') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="도메인" />
                    </ListItemButton>
                </Link>
            </>
            }
            {auth && role >= 4 &&
            <>
                <Link to="/appCompanyContacts" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appCompanyContact') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <ContactMailIcon color={splitLocation[1].includes('appCompanyContact') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="도입문의" />
                    </ListItemButton>
                </Link>
                
            </>
            }
            {auth && role >= 3 &&
            <>
                <Link to="/appCompanyContactImages" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appCompanyContactImage') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <PhotoCameraBackIcon color={splitLocation[1].includes('appCompanyContactImage') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="도입문의 이미지" />
                    </ListItemButton>
                </Link>
                <Link to="/appPartners" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appPartner') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <PeopleIcon color={splitLocation[1].includes('appPartner') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="제휴사" />
                    </ListItemButton>
                </Link>
            </>
            }
            {auth && role >= 4 &&
            <>
                <Link to="/appGifticons" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appGifticon') 
                        && !splitLocation[1].includes('appGifticonCategory')
                        && !splitLocation[1].includes('appGifticonExchange')
                        && !splitLocation[1].includes('appGifticonCompanyOrder')
                        && !splitLocation[1].includes('appGifticonCompanyOrderRefund') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <CardGiftcardIcon color={splitLocation[1].includes('appGifticon')
                                && !splitLocation[1].includes('appGifticonCategory')
                                && !splitLocation[1].includes('appGifticonExchange')
                                && !splitLocation[1].includes('appGifticonCompanyOrder')
                                && !splitLocation[1].includes('appGifticonCompanyOrderRefund') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="기프티콘" />
                    </ListItemButton>
                </Link>
                <Link to="/appGifticonCompanyOrders" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appGifticonCompanyOrder') 
                        && !splitLocation[1].includes('appGifticonCompanyOrderRefund') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <PaidIcon color={splitLocation[1].includes('appGifticonCompanyOrder')
                                && !splitLocation[1].includes('appGifticonCompanyOrderRefund') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="무통장입금" />
                    </ListItemButton>
                </Link>
                <Link to="/appGifticonCompanyOrderRefunds" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appGifticonCompanyOrderRefund') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <PaidIcon color={splitLocation[1].includes('appGifticonCompanyOrderRefund') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="환불요청" />
                    </ListItemButton>
                </Link>

                <Divider />

                <Link to="/appMarketings" className="link">
                    <ListItemButton sx={{ backgroundColor: splitLocation[1].includes('appMarketing') ? backgroundColor : '' }}>
                        <ListItemIcon>
                            <EmailIcon color={splitLocation[1].includes('appMarketing') ? 'secondary' : ''}/>
                        </ListItemIcon>
                        <ListItemText primary="마케팅이메일발송" />
                    </ListItemButton>
                </Link>
            </>
            }
        </div>
    )
}
